import { apiClient } from "../../../lib/apiClient";
import type { ApiResponse } from "../../../types/apiResponse";
import type { UpdateQuoteData } from "../types";

export const updateQuote = (payload: UpdateQuoteData) => {
   return apiClient<ApiResponse>("/v1/quote", {
      method: "PUT",
      body: payload
   })
}
